module.exports = __webpack_public_path__ + "img/product_icon_duomotai.03e30d32.png";